import { defineFeature } from '@/lib/platform/system';
import { scheduleMachine } from '@/features/schedule/state/schedule.machine';
import { stopSelectionMachine } from '@/features/stop-selection/state/stop-selection.machine';

export const features = [
  defineFeature({
    id: 'schedule',
    machine: scheduleMachine,
    emits: ['schedule.published'],
    handles: [],
    accepts: ['schedule.load-browse', 'schedule.publish'],
  }),
  defineFeature({
    id: 'stop-selection',
    machine: stopSelectionMachine,
    emits: [
      'selection.route-chosen',
      'selection.direction-chosen',
      'selection.stop-chosen',
      'scheduled-buses.calculated',
    ],
    handles: ['schedule.published'],
    accepts: [
      'stop-selection.load-view',
      'stop-selection.choose-route',
      'stop-selection.choose-direction',
      'stop-selection.choose-stop',
      'stop-selection.refresh',
    ],
  }),
] as const;
